import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useMonthlyEvolutionRegisters from './hooks/useMonthlyEvolutionRegisters';

export const MonthlyEvolutionRegisters = () => {
    const { chartConfig } = useMonthlyEvolutionRegisters();

    return (
        <ChartContainer
            title={"Evolução do cadastramento no ano"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
